import { render } from "./PodcastPlayer.vue?vue&type=template&id=7645c5e5&scoped=true"
import script from "./PodcastPlayer.vue?vue&type=script&lang=js"
export * from "./PodcastPlayer.vue?vue&type=script&lang=js"

import "./PodcastPlayer.vue?vue&type=style&index=0&id=7645c5e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7645c5e5"]])

export default __exports__